import { Component, OnInit } from '@angular/core';

const yaml = require('js-yaml');

import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbGlobalPhysicalPosition, NbIconLibraries } from '@nebular/theme';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpCenterCategoryService } from '../help-center-category.service';

@Component({
  selector: 'ngx-show-help-center-category',
  templateUrl: 'show-help-center-category.component.html',
  styleUrls: ['show-help-center-category.component.scss'],
})
export class ShowHelpCenterCategoryComponent implements OnInit {

  category: any = {};
  parentId = '';

  registerForm: FormGroup;
  submitted = false;

  icons: any = [];

  constructor(private route: ActivatedRoute,
    private toastrService: NbToastrService, private router: Router,
    private helpCenterCategoryService: HelpCenterCategoryService,
    private formBuilder: FormBuilder, private iconsLibrary: NbIconLibraries) {
    this.parentId = this.route.snapshot.params.parentId;
    this.getModule(this.parentId);
    this.createIconsCategory();
  }

  setIcon(iconClass) {
    this.category.icon = iconClass;
  }

  setMyStyles(icon) {
    if (icon.class === this.category.icon) {
      const styles = {
        'background-color': '#006b9c',
      };
      return styles;
    } else {
      return {};
    }
  }

  createIconsCategory() {
    this.icons = [
      {
        class: 'fas fa-graduation-cap',
      },
      {
        class: 'fas fa-user-graduate',
      },
      {
        class: 'fas fa-ambulance',
      },
      {
        class: 'fas fa-baby-carriage',
      },
      {
        class: 'fas fa-barcode',
      },
      {
        class: 'fab fa-black-tie',
      },
      {
        class: 'fas fa-bus',
      },
      {
        class: 'fas fa-cart-plus',
      },
      {
        class: 'far fa-handshake',
      },
      {
        class: 'far fa-heart',
      },
      {
        class: 'fas fa-gift',
      },
      {
        class: 'far fa-address-card',
      },
      {
        class: 'fas fa-air-freshener',
      },
      {
        class: 'fas fa-align-center',
      },
      {
        class: 'fas fa-allergies',
      },
      {
        class: 'fas fa-balance-scale-right',
      },
      {
        class: 'fas fa-blender-phone',
      },
      {
        class: 'fas fa-bicycle',
      },
      {
        class: 'fas fa-bolt',
      },
      {
        class: 'fas fa-bullhorn',
      },
      {
        class: 'fas fa-broom',
      },
      {
        class: 'fas fa-briefcase',
      }, {
        class: 'fab fa-accessible-icon'
      }, {
        class: 'fas fa-arrows-alt'
      },
      {
        class: 'fas fa-beer'
      }, {
        class: 'fas fa-birthday-cake',
      },
      {
        class: 'far fa-calendar-alt'
      }, 
      {
        class: 'fas fa-chart-bar'
      }, 
      {
        class: 'fas fa-child'
      }, 
      {
        class: 'fas fa-cocktail'
      },
      {
        class: 'fas fa-cogs',
      },
    ];
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    this.save();
  }

  getModule(parentId) {
    if (parentId === 'create') {
      this.category = {};
    } else {
      this.helpCenterCategoryService.find(this.parentId).toPromise().then(response => {
        this.category = response.body;
      }).catch(err => {
        this.toastrService.show('Categoria', 'Ocorreu um erro inesperado',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
      });
    }
  }

  goBack() {
    this.router.navigate(['pages/admin/help-center-category']);
  }

  save() {
    this.helpCenterCategoryService.create(this.category).toPromise().then(response => {
      this.toastrService.show('Categoria', 'Salvo com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.router.navigate(['pages/admin/help-center-category']);
    }).catch(err => {
      this.toastrService.show('Categoria', err.error.detail,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }

}
